<template>
  <div>
    <el-dialog
      title="编辑物流产品报价"
      width="1200px"
      custom-class="product-quotation__edit-dialog"
      :visible.sync="visibleValue"
      :modal-append-to-body="true"
      :append-to-body="true"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @closed="closedCallback"
    >
      <div slot="title" class="dialog-title">
        <div>编辑物流产品报价</div>
        <img
          :src="ossPath + '/pages/inquiryHall/ico-close-gray.png'"
          alt="关闭"
          @click="visibleValue = false"
        />
      </div>
      <div v-loading="loading">
        <el-form
          :model="editFormData"
          ref="editForm"
          label-width="150px"
          size="small"
          :inline="true"
          @submit.native.prevent
        >
          <el-tabs
            class="tab-pane-style"
            v-model="viewTypeListValue"
            @tab-click="handleClickViewType"
          >
            <el-tab-pane label="基本信息" name="baseInfo">
              <div class="edit-product-quotation__base-info">
                <div class="form-card-box">
                  <el-form-item
                    label="生效时间"
                    class="custom-range"
                    prop="effectiveEndTime"
                    :rules="formRules.require"
                  >
                    <el-date-picker
                      v-model="validTimeValue"
                      @change="changeValidTimeValue"
                      size="small"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm"
                      format="yyyy-MM-dd HH:mm"
                      range-separator="至"
                      :default-time="['00:00:01', '23:59:59']"
                      start-placeholder=""
                      end-placeholder=""
                      clearable
                      :disabled="copyVipPrice"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <!--<el-form-item label="报价等级" v-if="copyVipPrice">
                    <el-select value="" class="edit-form__input" disabled>
                      <el-option value="" label="普通价"></el-option>
                      <el-option value="" label="vip价"></el-option>
                    </el-select>
                  </el-form-item>-->
                  <br />

                  <el-form-item
                    label="运力商产品名称"
                    prop="logisticsProductCarrierId"
                    :rules="formRules.require"
                  >
                    <el-select
                      v-model="editFormData.logisticsProductCarrierId"
                      @change="selectChangeLogisticsProduct"
                      filterable
                      :disabled="!!editFormData.copyFromId"
                      size="small"
                      class="edit-form__input"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, index) in productList"
                        :key="index"
                        :label="item.label"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    label="货代拼产品名称"
                    v-show="isPrecondition"
                    prop="productname"
                    :rules="formRules.no"
                  >
                    <el-input
                      :value="editFormData.productname"
                      size="small"
                      disabled
                      class="edit-form__input"
                      placeholder=""
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="专线渠道代码"
                    prop="carrierProductCode"
                    :rules="formRules.no"
                  >
                    <el-input
                      :value="editFormData.carrierProductCode"
                      size="small"
                      disabled
                      class="edit-form__input"
                      placeholder=""
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="起运地"
                    v-show="isPrecondition"
                    prop="polnamec"
                    :rules="formRules.no"
                  >
                    <el-input
                      :value="editFormData.polnamec"
                      size="small"
                      disabled
                      class="edit-form__input"
                      placeholder=""
                    ></el-input>
                  </el-form-item>
                  <template v-if="isPrecondition">
                    <el-form-item
                      label="目的国家"
                      prop="podnamec"
                      :rules="formRules.no"
                    >
                      <el-input
                        :value="editFormData.podnamec"
                        size="small"
                        disabled
                        class="edit-form__input"
                        placeholder=""
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="收货城市"
                      prop="polCityList"
                      :rules="formRules.require"
                    >
                      <el-select
                        v-model="editFormData.polCityList"
                        @change="changeBaseCityList"
                        value-key="id"
                        multiple
                        clearable
                        filterable
                        size="small"
                        class="edit-form__input"
                        placeholder="请选择"
                        :disabled="copyVipPrice"
                      >
                        <el-option
                          v-for="item in logisticsProductsDetails.cityList"
                          :label="item.cityName"
                          :value="item"
                          :key="item.id"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="运输方式"
                      prop="transportType"
                      :rules="formRules.no"
                    >
                      <el-input
                        :value="
                          editFormData.transportNamec ||
                          allTransportTypesMapObject[
                            editFormData.transportType
                          ] ||
                          editFormData.transportType
                        "
                        size="small"
                        disabled
                        class="edit-form__input"
                        placeholder=""
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      :label="`${
                        transportCodeMapping[editFormData.transportType] ||
                        '运输'
                      }公司`"
                      prop="shippingCompanyList"
                      :rules="formRules.require"
                    >
                      <el-select
                        v-model="editFormData.shippingCompanyList"
                        filterable
                        multiple
                        :filter-method="transportCompanyFilterMethod"
                        size="small"
                        class="edit-form__input"
                        placeholder="请选择"
                        :disabled="copyVipPrice"
                      >
                        <el-option
                          v-for="item in transportCompanyListCopy"
                          :label="item.namec + '/' + item.code"
                          :value="item.id"
                          :key="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      :label="`${
                        logisticsProductsDetails.transportType === 'LY'
                          ? '车次'
                          : '航期'
                      }信息`"
                      prop="sailingTime"
                      :rules="formRules.require"
                    >
                      <el-form-item
                        label=""
                        label-width="0"
                        style="margin-bottom: 0"
                      >
                        <el-select
                          v-model="editFormData.closeWarehouseTime"
                          size="small"
                          style="width: 92px"
                          placeholder=""
                          :disabled="copyVipPrice"
                        >
                          <el-option
                            v-for="item in sailingInfoList"
                            :key="item"
                            :label="item"
                            :value="item"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        label=""
                        label-width="0"
                        style="margin-bottom: 0"
                      >
                        <el-select
                          v-model="editFormData.startShipmentTime"
                          size="small"
                          style="width: 92px"
                          placeholder=""
                          :disabled="copyVipPrice"
                        >
                          <el-option
                            v-for="item in sailingInfoList"
                            :key="item"
                            :label="item"
                            :value="item"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-form-item>
                    <!--<el-form-item label="专线api对接渠道代码"-->
                    <!--class="">-->
                    <!--<el-input v-model="editFormData.channelCode"-->
                    <!--size="small"-->
                    <!--class="edit-form__input"-->
                    <!--placeholder="请输入"></el-input>-->
                    <!--</el-form-item>-->
                    <!-- {{editFormData}} -->
                    <br />
                    <el-form-item
                      label="运输方案名称"
                      v-show="isPrecondition"
                      prop="transportScheme"
                      :rules="formRules.no"
                    >
                      <el-input
                        :value="editFormData.transportScheme"
                        size="small"
                        disabled
                        class="edit-form__input"
                        placeholder=""
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="海外仓"
                      prop="overseasWarehouseId"
                      :rules="formRules.require"
                    >
                      <el-select
                        v-model="editFormData.overseasWarehouseId"
                        filterable
                        size="small"
                        class="edit-form__input"
                        placeholder="请选择"
                        :disabled="copyVipPrice"
                      >
                        <el-option
                          v-for="item in overseasWarehouseList"
                          :label="item.warehouseName"
                          :value="item.id"
                          :key="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item
                      label="派送方式"
                      :style="
                        ['FP', 'HP'].includes(editFormData.deliveryType)
                          ? 'margin-right: 0'
                          : ''
                      "
                      prop="deliveryType"
                      :rules="formRules.require"
                    >
                      <el-select
                        v-model="editFormData.deliveryType"
                        @change="changeDeliveryType"
                        size="small"
                        class="edit-form__input"
                        :style="{
                          width: ['FP', 'HP'].includes(
                            editFormData.deliveryType
                          )
                            ? '100px'
                            : '200px',
                        }"
                        placeholder="请选择"
                        :disabled="copyVipPrice"
                      >
                        <el-option
                          v-for="item in deliveryTypeList"
                          :label="item.label"
                          :value="item.value"
                          :key="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label=""
                      label-width="0"
                      prop="endDeliveryTypeIds"
                      :rules="formRules.require"
                      v-if="
                        ['FP', 'HP', 'KH', 'TL'].includes(
                          editFormData.deliveryType
                        )
                      "
                    >
                      <el-select
                        v-model="editFormData.endDeliveryTypeIds"
                        size="small"
                        multiple
                        class="edit-form__input"
                        style="width: 95px"
                        placeholder="请选择"
                        :disabled="copyVipPrice"
                      >
                        <template v-if="editFormData.deliveryType === 'HP'">
                          <el-option
                            v-for="item in HPEndDeliveryList"
                            :label="item.namec"
                            :value="item.id"
                            :key="item.id"
                          ></el-option>
                        </template>
                        <template
                          v-else-if="editFormData.deliveryType === 'FP'"
                        >
                          <el-option
                            v-for="item in FPEndDeliveryList"
                            :label="item.namec"
                            :value="item.id"
                            :key="item.id"
                          ></el-option>
                        </template>
                        <template
                          v-else-if="editFormData.deliveryType === 'KH'"
                        >
                          <el-option
                            v-for="item in KHEndDeliveryList"
                            :label="item.namec"
                            :value="item.id"
                            :key="item.id"
                          ></el-option>
                        </template>
                        <template
                          v-else-if="editFormData.deliveryType === 'TL'"
                        >
                          <el-option
                            v-for="item in TLEndDeliveryList"
                            :label="item.namec"
                            :value="item.id"
                            :key="item.id"
                          ></el-option>
                        </template>
                      </el-select>
                    </el-form-item>
                    <template v-if="editFormData.deliveryType !== 'ZT'">
                      <el-form-item
                        label="是否支持自提"
                        prop="selfDelivery"
                        :rules="formRules.no"
                      >
                        <el-select
                          v-model="editFormData.selfDelivery"
                          size="small"
                          class="edit-form__input"
                          placeholder="请选择"
                          :disabled="copyVipPrice"
                        >
                          <el-option
                            v-for="item in selfDeliveryList"
                            :label="item.label"
                            :value="item.value"
                            :key="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                    <template v-if="editFormData.deliveryType === 'WC'">
                      <el-form-item
                        label="船期信息"
                        prop="shippingDateInformation"
                        :rules="formRules.no"
                      >
                        <el-input
                          v-model="editFormData.shippingDateInformation"
                          size="small"
                          class="edit-form__input"
                          placeholder=""
                          :disabled="copyVipPrice"
                        ></el-input>
                      </el-form-item>
                    </template>
                    <div class="custom-divider"></div>

                    <el-form-item
                      label="可走货物类型"
                      prop="goodsTypeList"
                      :rules="formRules.require"
                    >
                      <el-select
                        v-model="editFormData.goodsTypeList"
                        @change="changeBaseGoodsTypeList"
                        value-key="id"
                        multiple
                        clearable
                        filterable
                        size="small"
                        class="edit-form__input"
                        placeholder="请选择"
                        :disabled="copyVipPrice"
                      >
                        <el-option
                          v-for="item in goodsTypeList"
                          :label="`${item.goodsTypeName}(${item.countryName})`"
                          :value="item"
                          :key="item.id"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="计费单位"
                      prop="chargeType"
                      :rules="formRules.no"
                    >
                      <el-input
                        :value="editFormData.chargeType"
                        size="small"
                        disabled
                        class="edit-form__input"
                        placeholder=""
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="取整方式"
                      prop="scale"
                      v-if="isKG"
                      :rules="formRules.no"
                    >
                      <el-input
                        :value="
                          integerStyleListMapObject[
                            logisticsProductsDetails.scale
                          ] || logisticsProductsDetails.scale
                        "
                        size="small"
                        disabled
                        class="edit-form__input"
                        placeholder=""
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="取整方式"
                      prop="cbmScale"
                      v-if="isCBM"
                      :rules="formRules.no"
                    >
                      <el-input
                        :value="
                          integerStyleListMapObject[
                            logisticsProductsDetails.cbmScale
                          ] || logisticsProductsDetails.cbmScale
                        "
                        size="small"
                        disabled
                        class="edit-form__input"
                        placeholder=""
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="分泡方式"
                      prop="pointsBubbleWay"
                      v-if="isKG"
                      :rules="formRules.require"
                    >
                      <el-select
                        disabled
                        v-model="editFormData.pointsBubbleWay"
                        size="small"
                        class="edit-form__input"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="(item, index) in distributeBubbleList"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="体积重比率"
                      prop="volumeWeightRatio"
                      v-if="isKG"
                      :rules="formRules.require"
                    >
                      <el-input
                        v-model="editFormData.volumeWeightRatio"
                        size="small"
                        class="edit-form__input"
                        placeholder=""
                        :disabled="copyVipPrice"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      label="重量转换"
                      prop="weightVolumeRatio"
                      v-if="isCBM"
                      :rules="formRules.no"
                    >
                      <el-select
                        v-model="editFormData.weightVolumeRatio"
                        size="small"
                        class="edit-form__input"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="(item, index) in weightVolumeRatioList"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <div class="custom-divider"></div>
                    <el-form-item
                      label="是否接一般贸易"
                      prop="isSupportGeneralTrade"
                      :rules="formRules.no"
                    >
                      <el-input
                        :value="
                          editFormData.isSupportGeneralTrade ? '是' : '否'
                        "
                        disabled
                        size="small"
                        class="edit-form__input"
                        placeholder=""
                      ></el-input>
                      <!--<el-radio-group v-model="editFormData.isSupportGeneralTrade" disabled>
                        <el-radio :label="item.id" v-for="item in yesOrNo" :key="item.id">{{item.name}}</el-radio>
                      </el-radio-group>-->
                    </el-form-item>
                    <el-form-item
                      label="是否包关税"
                      prop="containsTheTariffs"
                      :rules="formRules.no"
                    >
                      <el-input
                        :value="editFormData.containsTheTariffs ? '是' : '否'"
                        disabled
                        size="small"
                        class="edit-form__input"
                        placeholder=""
                      ></el-input>
                      <!--<el-radio-group v-model="editFormData.containsTheTariffs" disabled>
                        <el-radio :label="item.id" v-for="item in yesOrNo" :key="item.id">{{item.name}}</el-radio>
                      </el-radio-group>-->
                    </el-form-item>
                    <el-form-item
                      label="是否需要VAT信息"
                      prop="isNeedVat"
                      :rules="formRules.no"
                    >
                      <el-input
                        :value="editFormData.isNeedVat ? '是' : '否'"
                        disabled
                        size="small"
                        class="edit-form__input"
                        placeholder=""
                      ></el-input>
                      <!--<el-radio-group v-model="editFormData.isNeedVat" disabled>
                        <el-radio :label="item.id" v-for="item in yesOrNo" :key="item.id">{{item.name}}</el-radio>
                      </el-radio-group>-->
                    </el-form-item>
                    <el-form-item
                      label="单票最小计费重"
                      prop="orderWeightMinimum"
                      :rules="
                        editFormData.orderWeightMinimumNotLimit
                          ? formRules.no
                          : formRules.require
                      "
                    >
                      <el-input
                        :value="editFormData.orderWeightMinimum"
                        disabled
                        size="small"
                        class="edit-form__input4"
                        placeholder=""
                      ></el-input>
                      <el-form-item
                        label="低于单票最小计费重能否下单："
                        label-width="210px"
                        prop="orderWeightMinimumNotLimit"
                        class="inner-form"
                        :rules="formRules.no"
                      >
                        <el-input
                          :value="
                            editFormData.orderWeightMinimumNotLimit
                              ? '是'
                              : '否'
                          "
                          disabled
                          size="small"
                          class="edit-form__input2"
                          placeholder=""
                        ></el-input>
                        <!--<el-radio-group v-model="editFormData.orderWeightMinimumNotLimit" disabled>
                          <el-radio :label="item.id" v-for="item in yesOrNo" :key="item.id">{{item.name}}</el-radio>
                        </el-radio-group>-->
                      </el-form-item>
                    </el-form-item>
                    <el-form-item
                      label="单件最小计费重"
                      prop="pieceWeightMinimum"
                      :rules="
                        editFormData.pieceWeightMinimumNotLimit
                          ? formRules.no
                          : formRules.require
                      "
                    >
                      <el-input
                        :value="editFormData.pieceWeightMinimum"
                        disabled
                        size="small"
                        class="edit-form__input4"
                        placeholder=""
                      ></el-input>
                      <el-form-item
                        label="低于单件最小计费重能否下单："
                        label-width="210px"
                        prop="pieceWeightMinimumNotLimit"
                        class="inner-form"
                        :rules="formRules.no"
                      >
                        <el-input
                          :value="
                            editFormData.pieceWeightMinimumNotLimit
                              ? '是'
                              : '否'
                          "
                          disabled
                          size="small"
                          class="edit-form__input2"
                          placeholder=""
                        ></el-input>
                        <!--<el-radio-group v-model="editFormData.pieceWeightMinimumNotLimit" disabled>
                          <el-radio :label="item.id" v-for="item in yesOrNo" :key="item.id">{{item.name}}</el-radio>
                        </el-radio-group>-->
                      </el-form-item>
                    </el-form-item>
                    <br />
                    <el-form-item
                      label="单件最大计费重"
                      prop="pieceWeightBiggest"
                      :rules="
                        editFormData.pieceWeightBiggestNotLimit
                          ? formRules.no
                          : formRules.require
                      "
                    >
                      <el-input
                        :value="editFormData.pieceWeightBiggest"
                        disabled
                        size="small"
                        class="edit-form__input4"
                        placeholder=""
                      ></el-input>
                      <el-form-item
                        label="低于单件最大计费重能否下单："
                        label-width="210px"
                        class="inner-form"
                        prop="pieceWeightBiggestNotLimit"
                        :rules="formRules.no"
                      >
                        <el-input
                          :value="
                            editFormData.pieceWeightBiggestNotLimit
                              ? '是'
                              : '否'
                          "
                          disabled
                          size="small"
                          class="edit-form__input2"
                          placeholder=""
                        ></el-input>
                        <!--<el-radio-group v-model="editFormData.pieceWeightBiggestNotLimit" disabled>
                           <el-radio :label="item.id" v-for="item in yesOrNo" :key="item.id">{{item.name}}</el-radio>
                         </el-radio-group>-->
                      </el-form-item>
                    </el-form-item>
                    <!--                  <el-form-item label="是否能走私人地址"-->
                    <!--                                label-width="130px"-->
                    <!--                                prop="isSupportPrivateAddress"-->
                    <!--                                :rules="formRules.no">-->
                    <!--                    <el-radio-group v-model="editFormData.isSupportPrivateAddress" disabled>-->
                    <!--                      <el-radio :label="item.id" v-for="item in yesOrNo" :key="item.id">{{item.name}}</el-radio>-->
                    <!--                    </el-radio-group>-->
                    <!--                  </el-form-item>-->
                  </template>
                </div>
                <div class="form-card-box">
                  <el-form-item
                    label="货物入仓测量方式"
                    prop="goodsMeasurementMethod"
                    :rules="formRules.require"
                  >
                    <!--<el-radio-group v-model="editFormData.goodsMeasurementMethod"
                                    size="small"
                                    class="edit-form__input">
                      <el-radio :label="1">机器量方</el-radio>
                      <el-radio :label="2">皮尺量方</el-radio>
                    </el-radio-group>-->
                    <el-select
                      v-model="editFormData.goodsMeasurementMethod"
                      size="small"
                      class="edit-form__input"
                      :disabled="copyVipPrice"
                    >
                      <el-option :value="1" label="机器量方"></el-option>
                      <el-option :value="2" label="皮尺量方"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    label="是否限时达产品"
                    prop="whetherGuaranteedDelivery"
                    :rules="formRules.require"
                  >
                    <!--<el-radio-group v-model="editFormData.whetherGuaranteedDelivery"
                                    size="small"
                                    class="edit-form__input">
                      <el-radio :label="true">是</el-radio>
                      <el-radio :label="false">否</el-radio>
                    </el-radio-group>-->
                    <el-select
                      v-model="editFormData.whetherGuaranteedDelivery"
                      size="small"
                      class="edit-form__input"
                      :disabled="copyVipPrice"
                    >
                      <el-option :value="true" label="是"></el-option>
                      <el-option :value="false" label="否"></el-option>
                    </el-select>
                  </el-form-item>
                  <!--<el-form-item label="是否支持线下议价"
                                prop="whetherSupportedBargaining"
                                label-width="123px"
                                :rules="formRules.require">
                    <el-radio-group v-model="editFormData.whetherSupportedBargaining"
                                    size="small"
                                    class="edit-form__input">
                      <el-radio :label="true">是</el-radio>
                      <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                  </el-form-item>-->
                  <br />
                  <el-form-item
                    label="是否支持时效赔付"
                    prop="whetherSupported"
                    :rules="formRules.whetherSupported"
                  >
                    <!--<el-radio-group v-model="editFormData.whetherSupportedCompensate"
                                    size="small"
                                    class="edit-form__input">
                      <el-radio :label="true">是</el-radio>
                      <el-radio :label="false">否</el-radio>
                    </el-radio-group>-->
                    <el-select
                      v-model="editFormData.whetherSupportedCompensate"
                      size="small"
                      class="edit-form__input"
                      :disabled="copyVipPrice"
                    >
                      <el-option :value="true" label="是"></el-option>
                      <el-option :value="false" label="否"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    label="时效赔付标准"
                    v-if="editFormData.whetherSupportedCompensate"
                    :rules="formRules.require"
                  >
                    <el-input
                      v-model="editFormData.supportedCompensateDesc"
                      size="small"
                      :rows="1"
                      maxlength="50"
                      style="width: 550px"
                      class="edit-form__input"
                      :disabled="copyVipPrice"
                    ></el-input>
                  </el-form-item>
                  <br />
                  <el-form-item
                    label="是否支持丢货赔付"
                    prop="whetherSupportCompensation"
                    :rules="formRules.require"
                  >
                    <!--<el-radio-group v-model="editFormData.whetherSupportCompensation"
                                    size="small"
                                    class="edit-form__input">
                      <el-radio :label="true">支持</el-radio>
                      &lt;!&ndash;<el-radio :label="false">不支持</el-radio>&ndash;&gt;
                    </el-radio-group-->
                    <el-select
                      v-model="editFormData.whetherSupportCompensation"
                      size="small"
                      class="edit-form__input"
                      :disabled="copyVipPrice"
                    >
                      <el-option :value="true" label="是"></el-option>
                      <!--<el-option :value="false" label="否"></el-option>-->
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    label="丢货赔付标准"
                    v-if="editFormData.whetherSupportCompensation"
                    :rules="formRules.require"
                  >
                    <el-input
                      v-model="editFormData.supportCompensationDesc"
                      size="small"
                      :rows="1"
                      maxlength="50"
                      style="width: 550px"
                      class="edit-form__input"
                      :disabled="copyVipPrice"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="产品自定义标签" prop="">
                    <el-input
                      v-model="editFormData.label1"
                      size="small"
                      class="edit-form__input margin-right-sm"
                      placeholder="标签1"
                      :disabled="copyVipPrice"
                    ></el-input>
                    <el-input
                      v-model="editFormData.label2"
                      size="small"
                      class="edit-form__input margin-right-sm"
                      placeholder="标签2"
                      :disabled="copyVipPrice"
                    ></el-input>
                    <el-input
                      v-model="editFormData.label3"
                      size="small"
                      class="edit-form__input margin-right-sm"
                      placeholder="标签3"
                      :disabled="copyVipPrice"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="form-card-box">
                  <div class="" style="margin-bottom: 15px">
                    <button
                      class="el-button button-style-small"
                      :class="{
                        'el-button--primary': editorTarget === item.id,
                      }"
                      style="width: 80px; padding: 0; line-height: 1"
                      :style="editorTarget === item.id ? 'color: #FFF' : ''"
                      :disabled="item.disabled"
                      v-for="item in editorTargetList"
                      :key="item.id"
                      @click="changeEditorTarget(item.id)"
                      type="button"
                    >
                      <span>{{ item.name }}</span>
                    </button>
                  </div>
                  <div id="editBox" style="width: 100%"></div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane
              label="运费价格设置"
              :disabled="!isPrecondition"
              name="freightPriceSetting"
            >
              <div class="edit-product-quotation__freight-price">
                <div class="form-card-box">
                  <el-form-item
                    label="是否多渠道"
                    label-width="100px"
                    class="form-item-mb-0"
                    prop="isSupportMultiChannel"
                    :rules="formRules.no"
                  >
                    <el-select
                      v-model="editFormData.isSupportMultiChannel"
                      @change="changeMultipleChannels"
                      class="edit-form__input"
                      size="small"
                      :disabled="copyVipPrice"
                    >
                      <el-option :value="true" label="是">是</el-option>
                      <el-option :value="false" label="否">否</el-option>
                    </el-select>
                  </el-form-item>
                  <template v-if="editFormData.isSupportMultiChannel === false">
                    <el-form-item
                      label="专线api对接渠道代码"
                      label-width="170px"
                      prop="channelCode"
                      class="form-item-mb-0"
                      :rules="formRules.no"
                    >
                      <!--                    <el-input v-model="editFormData.channelCode"-->
                      <!--                              @change="changeSingleChannelCode"-->
                      <!--                              class="edit-form__input"-->
                      <!--                              size="small"/>-->
                      <select-api-channel-code
                        v-model="editFormData.channelCode"
                        :can-get="canGetChannelCode"
                        :loading="apiChannelCodeListLoading"
                        :status="apiChannelCodeListGetStatus"
                        :list="apiChannelCodeList"
                        :time-out-number="apiChannelCodeRequestSpace"
                        @clickBtn="startGetChannelCodeList"
                        @change="changeSingleChannelCode"
                        class="api-channel-code"
                        :disabled="copyVipPrice"
                      />
                    </el-form-item>
                    <br />
                  </template>
                </div>

                <div class="form-card-box">
                  <div class="column-title">
                    分区设置
                    <span
                      style="font-size: 12px; font-weight: 400; color: #666"
                    >
                      （{{
                        logisticsProductsDetails.isSegment ? "分段" : "全包"
                      }}）
                    </span>
                  </div>
                  <template v-if="logisticsProductsDetails.isSegment">
                    <!-- 头程/派送 切换按钮 -->
                    <div class="margin-bottom-sm segment-button-container">
                      <el-button
                        size="small"
                        @click="changeRegionQuotationType(item, index)"
                        :type="
                          item.value === regionQuotationTypeCurrent
                            ? 'primary'
                            : ''
                        "
                        :disabled="regionTabsDisabled(item)"
                        v-for="(item, index) in regionQuotationTypeList"
                        :key="index"
                      >
                        {{ item.label }}</el-button
                      >
                    </div>
                    <template v-if="regionQuotationTypeCurrent === 'delivery'">
                      <el-form-item label="币种(派送)" label-width="90px">
                        <el-select
                          v-model="currencyDelivery"
                          size="small"
                          class="edit-form__input"
                          placeholder="请选择"
                          :disabled="copyVipPrice"
                        >
                          <el-option
                            v-for="(item, index) in currencyList"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>

                      <!--                    <region-name-and-select-->
                      <!--                      :region-type="editFormData.regionType"-->
                      <!--                      :charge-type="getTableHeadChargeType(logisticsProductsDetails.deliveryTableHeadList)"-->
                      <!--                      :list="deliveryRegionHeaderList"-->
                      <!--                      :subarea-list="subareaList"-->
                      <!--                      :table-head-list="logisticsProductsDetails.deliveryTableHeadList"-->
                      <!--                      :is-segment="logisticsProductsDetails.isSegment"-->
                      <!--                      :type="2"-->
                      <!--                      :is-support-multi-channel="editFormData.isSupportMultiChannel"-->
                      <!--                    />-->

                      <city-region-name-and-select
                        :region-type="editFormData.regionType"
                        :charge-type="
                          getTableHeadChargeType(
                            logisticsProductsDetails.deliveryTableHeadList
                          )
                        "
                        :list="deliveryRegionHeaderList"
                        :subarea-list="subareaList"
                        :table-head-list="
                          logisticsProductsDetails.deliveryTableHeadList
                        "
                        :is-segment="logisticsProductsDetails.isSegment"
                        :type="2"
                        :global-channel-code="editFormData.channelCode"
                        :is-support-multi-channel="
                          editFormData.isSupportMultiChannel
                        "
                        :open-custom-goods-type="false"
                        :is-support-multi-goods-type-price="0"
                        :goods-type-list="[]"
                        @addedRegion="
                          refreshCityRegionHeaderPriceTable(
                            'delivery',
                            deliveryRegionHeaderList
                          )
                        "
                        @removeRegion="
                          refreshCityRegionHeaderPriceTable(
                            'delivery',
                            deliveryRegionHeaderList
                          )
                        "
                        @addedPricePlan="
                          refreshCityRegionHeaderPriceTable(
                            'delivery',
                            deliveryRegionHeaderList
                          )
                        "
                        @removePricePlan="
                          refreshCityRegionHeaderPriceTable(
                            'delivery',
                            deliveryRegionHeaderList
                          )
                        "
                        @changeRegionName="
                          (val, regionItem) =>
                            refreshSingleRowRegionName(
                              val,
                              regionItem,
                              'delivery'
                            )
                        "
                        @changeRegionDetailList="
                          refreshCityRegionHeaderPriceTable(
                            'delivery',
                            deliveryRegionHeaderList
                          )
                        "
                        :can-get-channel-code="canGetChannelCode"
                        :api-channel-code-list-loading="
                          apiChannelCodeListLoading
                        "
                        :api-channel-code-list-get-status="
                          apiChannelCodeListGetStatus
                        "
                        :api-channel-code-list="apiChannelCodeList"
                        :api-channel-code-request-space="
                          apiChannelCodeRequestSpace
                        "
                        @clickGetApiChannelCode="startGetChannelCodeList"
                        :disabled="copyVipPrice"
                      />
                    </template>
                    <template v-else>
                      <el-form-item label="币种(头程)" label-width="90px">
                        <el-select
                          v-model="currency"
                          size="small"
                          class="edit-form__input"
                          placeholder="请选择"
                          :disabled="copyVipPrice"
                        >
                          <el-option
                            v-for="(item, index) in currencyList"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        label="是否按最小分区设置转换比"
                        label-width="220px"
                      >
                        <el-select
                          v-model="isConvertOnPartition"
                          size="small"
                          class="edit-form__input"
                          placeholder="请选择"
                          :disabled="copyVipPrice"
                        >
                          <el-option label="是" :value="true"></el-option>
                          <el-option label="否" :value="false"></el-option>
                        </el-select>
                      </el-form-item>
                      <!-- 城市tab -->
                      <city-tabs-row
                        :list="cityRegionHeaderList"
                        :default-current-value.sync="cityRegionHeaderCurrent"
                        :open-added="
                          !!filterUnselectedList(
                            editFormData.polCityList,
                            alreadySelectStartCityList,
                            [],
                            'id'
                          ).length
                        "
                        :closable="!!cityRegionHeaderList.length"
                        @remove="
                          refreshCityRegionHeaderPriceTable(
                            'head',
                            cityRegionHeaderList
                          )
                        "
                      />
                      <city-region
                        v-show="cityRegionHeaderCurrent === item._id"
                        v-for="(item, index) in cityRegionHeaderList"
                        :key="'region_' + item._id"
                        :city-region-header-item="item"
                        :origin-city-list="editFormData.polCityList"
                        :un-selected-city-list="
                          filterUnselectedList(
                            editFormData.polCityList,
                            alreadySelectStartCityList,
                            item.cityList,
                            'id'
                          )
                        "
                        :goods-type-list="editFormData.goodsTypeList"
                        :start-city-setting-warehouse-params="
                          startCitySettingWarehouseParams
                        "
                        :start-city-setting-warehouse-params-loading="
                          startCitySettingWarehouseParamsLoading
                        "
                        @changeCityValue="
                          (val) =>
                            refreshSingleCityRegionSelectCityValue(val, item)
                        "
                        @changeMultiGoodsTypePrice="
                          (val) =>
                            changeSupportMultiGoodsTypePrice(val, item, 'head')
                        "
                      >
                        <city-region-name-and-select
                          :region-type="3"
                          :charge-type="
                            getTableHeadChargeType(
                              logisticsProductsDetails.tableHeadList
                            )
                          "
                          :list="item.regionHeaderList"
                          :subarea-list="subareaListCity"
                          :cg-city-list="cgCityList"
                          :table-head-list="
                            logisticsProductsDetails.tableHeadList
                          "
                          :visible-added-btn="!item.regionHeaderList.length"
                          :is-segment="logisticsProductsDetails.isSegment"
                          :type="1"
                          :global-channel-code="editFormData.channelCode"
                          :is-support-multi-channel="
                            editFormData.isSupportMultiChannel
                          "
                          :is-support-multi-goods-type-price="
                            item.isSupportMultiGoodsTypePrice
                          "
                          :goods-type-list="editFormData.goodsTypeList"
                          :isShowRatioSetting="isConvertOnPartition"
                          @addedRegion="
                            refreshCityRegionHeaderPriceTable(
                              'head',
                              cityRegionHeaderList
                            )
                          "
                          @removeRegion="
                            refreshCityRegionHeaderPriceTable(
                              'head',
                              cityRegionHeaderList
                            )
                          "
                          @addedPricePlan="
                            refreshCityRegionHeaderPriceTable(
                              'head',
                              cityRegionHeaderList
                            )
                          "
                          @removePricePlan="
                            refreshCityRegionHeaderPriceTable(
                              'head',
                              cityRegionHeaderList
                            )
                          "
                          @changeRegionName="
                            (val, regionItem) =>
                              refreshSingleRowRegionName(
                                val,
                                regionItem,
                                'head'
                              )
                          "
                          @changeRegionDetailList="
                            refreshCityRegionHeaderPriceTable(
                              'head',
                              cityRegionHeaderList
                            )
                          "
                          @changeDismantlingCity="
                            refreshCityRegionHeaderPriceTable(
                              'head',
                              cityRegionHeaderList
                            )
                          "
                          :can-get-channel-code="canGetChannelCode"
                          :api-channel-code-list-loading="
                            apiChannelCodeListLoading
                          "
                          :api-channel-code-list-get-status="
                            apiChannelCodeListGetStatus
                          "
                          :api-channel-code-list="apiChannelCodeList"
                          :api-channel-code-request-space="
                            apiChannelCodeRequestSpace
                          "
                          @clickGetApiChannelCode="startGetChannelCodeList"
                          :disabled="copyVipPrice"
                        />
                      </city-region>
                    </template>
                    <template v-if="cityRegionHeaderPriceTable.length">
                      <div class="column-title">头程报价</div>
                      <city-custom-quotation-list
                        is-segment
                        open-custom
                        :is-support-multi-channel="
                          editFormData.isSupportMultiChannel
                        "
                        :list="cityRegionHeaderPriceTable"
                        :table-header-list="
                          logisticsProductsDetails.tableHeadList
                        "
                        :type="1"
                        @changeAging="
                          (data, target) =>
                            refreshSinglePriceRowAging(data, target, 'head')
                        "
                        key="head"
                        :isShowRatioSetting="isConvertOnPartition"
                        :copy-vip-price="copyVipPrice"
                      />
                    </template>
                    <template v-if="deliveryCityRegionHeaderPriceTable.length">
                      <div class="column-title">派送报价</div>
                      <city-custom-quotation-list
                        is-segment
                        open-custom
                        open-set-free-delivery
                        :is-support-multi-channel="
                          editFormData.isSupportMultiChannel
                        "
                        :list="deliveryCityRegionHeaderPriceTable"
                        :table-header-list="
                          logisticsProductsDetails.deliveryTableHeadList
                        "
                        :type="2"
                        @changeAging="
                          (data, target) =>
                            refreshSinglePriceRowAging(data, target, 'delivery')
                        "
                        key="delivery"
                        :copy-vip-price="copyVipPrice"
                      />
                    </template>
                  </template>
                  <template v-else>
                    <el-form-item label="币种" label-width="50px">
                      <el-select
                        v-model="currency"
                        size="small"
                        class="edit-form__input"
                        placeholder="请选择"
                        :disabled="copyVipPrice"
                      >
                        <el-option
                          v-for="(item, index) in currencyList"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="是否按最小分区设置转换比"
                      label-width="220px"
                    >
                      <el-select
                        v-model="isConvertOnPartition"
                        size="small"
                        class="edit-form__input"
                        placeholder="请选择"
                        :disabled="copyVipPrice"
                      >
                        <el-option label="是" :value="true"></el-option>
                        <el-option label="否" :value="false"></el-option>
                      </el-select>
                    </el-form-item>
                    <!-- 城市tab -->
                    <city-tabs-row
                      :list="cityRegionHeaderList"
                      :default-current-value.sync="cityRegionHeaderCurrent"
                      :open-added="
                        !!filterUnselectedList(
                          editFormData.polCityList,
                          alreadySelectStartCityList,
                          [],
                          'id'
                        ).length
                      "
                      :closable="!!cityRegionHeaderList.length"
                      @remove="
                        refreshCityRegionHeaderPriceTable(
                          'all',
                          cityRegionHeaderList
                        )
                      "
                    />
                    <city-region
                      v-show="cityRegionHeaderCurrent === item._id"
                      v-for="(item, index) in cityRegionHeaderList"
                      :key="'region_' + item._id"
                      :city-region-header-item="item"
                      :origin-city-list="editFormData.polCityList"
                      :un-selected-city-list="
                        filterUnselectedList(
                          editFormData.polCityList,
                          alreadySelectStartCityList,
                          item.cityList,
                          'id'
                        )
                      "
                      :goods-type-list="editFormData.goodsTypeList"
                      :start-city-setting-warehouse-params="
                        startCitySettingWarehouseParams
                      "
                      :start-city-setting-warehouse-params-loading="
                        startCitySettingWarehouseParamsLoading
                      "
                      @changeCityValue="
                        (val) =>
                          refreshSingleCityRegionSelectCityValue(val, item)
                      "
                      @changeMultiGoodsTypePrice="
                        (val) =>
                          changeSupportMultiGoodsTypePrice(val, item, 'all')
                      "
                      :disabled="copyVipPrice"
                    >
                      <city-region-name-and-select
                        :region-type="editFormData.regionType"
                        :charge-type="
                          getTableHeadChargeType(
                            logisticsProductsDetails.tableHeadList
                          )
                        "
                        :list="item.regionHeaderList"
                        :subarea-list="subareaList"
                        :cg-city-list="cgCityList"
                        :table-head-list="
                          logisticsProductsDetails.tableHeadList
                        "
                        :is-segment="logisticsProductsDetails.isSegment"
                        :type="1"
                        :global-channel-code="editFormData.channelCode"
                        :is-support-multi-channel="
                          editFormData.isSupportMultiChannel
                        "
                        :is-support-multi-goods-type-price="
                          item.isSupportMultiGoodsTypePrice
                        "
                        :goods-type-list="editFormData.goodsTypeList"
                        :isShowRatioSetting="isConvertOnPartition"
                        @addedRegion="
                          refreshCityRegionHeaderPriceTable(
                            'all',
                            cityRegionHeaderList
                          )
                        "
                        @removeRegion="
                          refreshCityRegionHeaderPriceTable(
                            'all',
                            cityRegionHeaderList
                          )
                        "
                        @addedPricePlan="
                          refreshCityRegionHeaderPriceTable(
                            'all',
                            cityRegionHeaderList
                          )
                        "
                        @removePricePlan="
                          refreshCityRegionHeaderPriceTable(
                            'all',
                            cityRegionHeaderList
                          )
                        "
                        @changeRegionName="
                          (val, regionItem) =>
                            refreshSingleRowRegionName(val, regionItem, 'all')
                        "
                        @changeRegionDetailList="
                          refreshCityRegionHeaderPriceTable(
                            'all',
                            cityRegionHeaderList
                          )
                        "
                        @changeDismantlingCity="
                          refreshCityRegionHeaderPriceTable(
                            'all',
                            cityRegionHeaderList
                          )
                        "
                        :can-get-channel-code="canGetChannelCode"
                        :api-channel-code-list-loading="
                          apiChannelCodeListLoading
                        "
                        :api-channel-code-list-get-status="
                          apiChannelCodeListGetStatus
                        "
                        :api-channel-code-list="apiChannelCodeList"
                        :api-channel-code-request-space="
                          apiChannelCodeRequestSpace
                        "
                        @clickGetApiChannelCode="startGetChannelCodeList"
                        :disabled="copyVipPrice"
                      />
                    </city-region>
                    <city-custom-quotation-list
                      open-custom
                      :is-support-multi-channel="
                        editFormData.isSupportMultiChannel
                      "
                      :list="cityRegionHeaderPriceTable"
                      :table-header-list="
                        logisticsProductsDetails.tableHeadList
                      "
                      :type="1"
                      @changeAging="
                        (data, target) =>
                          refreshSinglePriceRowAging(data, target, 'all')
                      "
                      key="all"
                      :isShowRatioSetting="isConvertOnPartition"
                      :copy-vip-price="copyVipPrice"
                    />
                  </template>
                </div>
                <div class="form-card-box">
                  <el-form-item
                    label="是否推送更新至收藏客户"
                    class="is-min-width form-item-mb-0"
                    prop="pushOpen"
                    label-width="190px"
                    :rules="formRules.no"
                  >
                    <el-select
                      v-model="editFormData.pushOpen"
                      class="edit-form__input"
                      size="small"
                      :disabled="copyVipPrice"
                    >
                      <el-option :value="true" label="是">是</el-option>
                      <el-option :value="false" label="否">否</el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    label="推送更新说明"
                    class="is-min-width form-item-mb-0"
                    prop="pushContent"
                    label-width="180px"
                    v-if="editFormData.pushOpen"
                    :rules="formRules.no"
                  >
                    <el-input
                      v-model="editFormData.pushContent"
                      type="textarea"
                      :rows="6"
                      maxlength="100"
                      show-word-limit
                      class="edit-form__input"
                      style="width: 400px"
                      placeholder="请填写更新说明（必填）"
                      :disabled="copyVipPrice"
                    />
                  </el-form-item>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane
              label="增值服务价格设置"
              :disabled="!isPrecondition"
              name="addedServicePriceSetting"
            >
              <div class="edit-product-quotation__added-service">
                <template
                  v-if="
                    editFormData.addedServiceList &&
                    editFormData.addedServiceList.length
                  "
                >
                  <div class="form-card-box">
                    <template
                      v-for="(item, index) in editFormData.addedServiceList"
                    >
                      <el-radio-group
                        v-model="editFormData.addedServiceList[index].isPremium"
                        v-if="item.code !== 'FB023'"
                        class="radio-group-row"
                        :disabled="copyVipPrice"
                      >
                        <el-radio
                          :label="item.id"
                          v-for="item in isPremiumList"
                          :key="item.id"
                          >{{ item.name }}</el-radio
                        >
                      </el-radio-group>
                      <el-form-item
                        :label="item.name"
                        :prop="'addedServiceList[' + index + '].price'"
                        label-width="130px"
                        :rules="
                          editFormData.addedServiceList[index].isPremium !== 1
                            ? formRules.no
                            : formRules[item.rulesKey]
                        "
                        v-if="item.useDefaultTemplate"
                        class=""
                      >
                        <span slot="label" class="service-name">{{
                          item.name
                        }}</span>
                        <el-input
                          v-model="editFormData.addedServiceList[index].price"
                          size="small"
                          class="edit-form__input"
                          placeholder="请输入"
                          :disabled="copyVipPrice"
                        ></el-input>
                        <span class="symbol input-after">{{
                          item.priceUnitText
                        }}</span>
                      </el-form-item>
                      <div class="the-form-item" v-else>
                        <div class="the-form-item__label service-name">
                          {{ item.name }}
                        </div>
                        <div class="the-form-item__content">
                          <!--VAT服务费-->
                          <template v-if="item.code === 'FB014'">
                            <span class="input-before">每票关税的</span>
                            <el-form-item
                              label="VAT服务费"
                              :prop="'addedServiceList[' + index + '].price'"
                              :rules="
                                editFormData.addedServiceList[index]
                                  .isPremium !== 1
                                  ? formRules.no
                                  : formRules.require
                              "
                              class="hide-label"
                            >
                              <el-input
                                v-model="
                                  editFormData.addedServiceList[index].price
                                "
                                size="small"
                                class="edit-form__input"
                                placeholder="请输入"
                                :disabled="copyVipPrice"
                              ></el-input>
                              <span class="symbol input-after">%</span>
                            </el-form-item>
                          </template>
                          <!--超重费-->
                          <template v-if="item.code === 'FB017'">
                            <span class="input-before">单件大于</span>
                            <el-form-item
                              label="超重(拒收阈值)"
                              :prop="
                                'addedServiceList[' + index + '].chargeLimit'
                              "
                              :rules="
                                editFormData.addedServiceList[index]
                                  .isPremium !== 1
                                  ? formRules.no
                                  : formRules.require
                              "
                              class="hide-label"
                            >
                              <el-input
                                v-model="
                                  editFormData.addedServiceList[index]
                                    .chargeLimit
                                "
                                size="small"
                                class="edit-form__input"
                                placeholder="请输入"
                                :disabled="copyVipPrice"
                              ></el-input>
                            </el-form-item>
                            <span class="symbol input-after">KG拒收</span>
                            <br />
                            <span class="input-before">单件大于</span>
                            <el-form-item
                              label="超重(大于)"
                              :prop="
                                'addedServiceList[' + index + '].chargeFrom'
                              "
                              :rules="
                                editFormData.addedServiceList[index]
                                  .isPremium !== 1
                                  ? formRules.no
                                  : formRules.require
                              "
                              class="hide-label"
                            >
                              <el-input
                                v-model="
                                  editFormData.addedServiceList[index]
                                    .chargeFrom
                                "
                                size="small"
                                class="edit-form__input3"
                                placeholder="请输入"
                                :disabled="copyVipPrice"
                              ></el-input>
                            </el-form-item>
                            <span class="symbol input-after">KG，</span>
                            <span class="symbol input-after">小于</span>
                            <el-form-item
                              label="超重(小于)"
                              :prop="'addedServiceList[' + index + '].chargeTo'"
                              :rules="
                                editFormData.addedServiceList[index]
                                  .isPremium !== 1
                                  ? formRules.no
                                  : formRules.require
                              "
                              class="hide-label"
                            >
                              <el-input
                                v-model="
                                  editFormData.addedServiceList[index].chargeTo
                                "
                                size="small"
                                class="edit-form__input4"
                                placeholder="请输入"
                                :disabled="copyVipPrice"
                              ></el-input>
                            </el-form-item>
                            <span class="symbol input-after">KG，</span>
                            <span class="symbol input-after">加收</span>
                            <el-form-item
                              label="超重费"
                              :prop="'addedServiceList[' + index + '].price'"
                              :rules="
                                editFormData.addedServiceList[index]
                                  .isPremium !== 1
                                  ? formRules.no
                                  : formRules.require
                              "
                              class="hide-label"
                            >
                              <el-input
                                v-model="
                                  editFormData.addedServiceList[index].price
                                "
                                size="small"
                                class="edit-form__input4"
                                placeholder="请输入"
                                :disabled="copyVipPrice"
                              ></el-input>
                            </el-form-item>
                            <span class="symbol input-after">RMB/件</span>
                          </template>
                          <!--超轻费-->
                          <template v-if="item.code === 'FB018'">
                            <span class="input-before">单件小于</span>
                            <el-form-item
                              label="超轻(小于)"
                              :prop="
                                'addedServiceList[' + index + '].minimumLimit'
                              "
                              :rules="
                                editFormData.addedServiceList[index]
                                  .isPremium !== 1
                                  ? formRules.no
                                  : formRules.require
                              "
                              class="hide-label"
                            >
                              <el-input
                                v-model="
                                  editFormData.addedServiceList[index]
                                    .minimumLimit
                                "
                                size="small"
                                class="edit-form__input3"
                                placeholder="请输入"
                                :disabled="copyVipPrice"
                              ></el-input>
                            </el-form-item>
                            <span class="symbol input-after">KG，</span>
                            <span class="symbol input-after">加收</span>
                            <el-form-item
                              label="超轻费"
                              :prop="'addedServiceList[' + index + '].price'"
                              :rules="
                                editFormData.addedServiceList[index]
                                  .isPremium !== 1
                                  ? formRules.no
                                  : formRules.require
                              "
                              class="hide-label"
                            >
                              <el-input
                                v-model="
                                  editFormData.addedServiceList[index].price
                                "
                                size="small"
                                class="edit-form__input3"
                                placeholder="请输入"
                                :disabled="copyVipPrice"
                              ></el-input>
                            </el-form-item>
                            <span class="symbol input-after">RMB/件</span>
                          </template>
                          <!--一般贸易报关费-->
                          <template v-if="item.code === 'FB019'">
                            <span class="input-before">最低收费</span>
                            <el-form-item
                              label="报关费(最低)"
                              :prop="
                                'addedServiceList[' + index + '].minimumCharge'
                              "
                              :rules="
                                editFormData.addedServiceList[index]
                                  .isPremium !== 1
                                  ? formRules.no
                                  : formRules.require
                              "
                              class="hide-label"
                            >
                              <el-input
                                v-model="
                                  editFormData.addedServiceList[index]
                                    .minimumCharge
                                "
                                size="small"
                                class="edit-form__input3"
                                placeholder="请输入"
                                :disabled="copyVipPrice"
                              ></el-input>
                            </el-form-item>
                            <span class="input-after">RMB/票</span>
                            <br />
                            <span class="input-before">每票大于</span>
                            <el-form-item
                              label="报关数(大于)"
                              :prop="'addedServiceList[' + index + '].baseNum'"
                              :rules="
                                editFormData.addedServiceList[index]
                                  .isPremium !== 1
                                  ? formRules.no
                                  : formRules.require
                              "
                              class="hide-label"
                            >
                              <el-input
                                v-model="
                                  editFormData.addedServiceList[index].baseNum
                                "
                                size="small"
                                class="edit-form__input3"
                                placeholder="请输入"
                                :disabled="copyVipPrice"
                              ></el-input>
                            </el-form-item>
                            <span class="symbol input-after">品名，</span>
                            <span class="symbol input-after"
                              >每增加一个品名收</span
                            >
                            <el-form-item
                              label="报关费(加收)"
                              :prop="'addedServiceList[' + index + '].price'"
                              :rules="
                                editFormData.addedServiceList[index]
                                  .isPremium !== 1
                                  ? formRules.no
                                  : formRules.require
                              "
                              class="hide-label"
                            >
                              <el-input
                                v-model="
                                  editFormData.addedServiceList[index].price
                                "
                                size="small"
                                class="edit-form__input3"
                                placeholder="请输入"
                                :disabled="copyVipPrice"
                              ></el-input>
                            </el-form-item>
                            <span class="symbol input-after">RMB/件</span>
                          </template>
                          <!--偏远费-->
                          <template v-if="item.code === 'FB020'">
                            <el-form-item
                              label="偏远费"
                              :prop="'addedServiceList[' + index + '].price'"
                              :rules="
                                editFormData.addedServiceList[index]
                                  .isPremium !== 1
                                  ? formRules.no
                                  : formRules.require
                              "
                              class="hide-label"
                            >
                              <el-input
                                v-model="
                                  editFormData.addedServiceList[index].price
                                "
                                size="small"
                                class="edit-form__input3"
                                placeholder="请输入"
                                :disabled="copyVipPrice"
                              ></el-input>
                            </el-form-item>
                            <span class="symbol input-after">RMB/ </span>
                            <el-form-item
                              label="偏远费(单位)"
                              :prop="
                                'addedServiceList[' + index + '].priceUnit'
                              "
                              :rules="
                                editFormData.addedServiceList[index]
                                  .isPremium !== 1
                                  ? formRules.no
                                  : formRules.require
                              "
                              class="hide-label"
                            >
                              <el-select
                                v-model="
                                  editFormData.addedServiceList[index].priceUnit
                                "
                                size="small"
                                class="edit-form__input4"
                                placeholder="单位"
                                :disabled="copyVipPrice"
                              >
                                <el-option
                                  v-for="(item, index) in priceUnitList"
                                  :key="index"
                                  :label="item.namec"
                                  :value="item.namec"
                                ></el-option>
                              </el-select>
                            </el-form-item>
                          </template>
                          <!--大型包裹费-->
                          <template v-if="item.code === 'FB021'">
                            <span class="input-before">外箱尺寸单边大于</span>
                            <el-form-item
                              label="大型包裹尺寸(拒收阈值)"
                              :prop="
                                'addedServiceList[' + index + '].chargeLimit'
                              "
                              :rules="
                                editFormData.addedServiceList[index]
                                  .isPremium !== 1
                                  ? formRules.no
                                  : formRules.require
                              "
                              class="hide-label"
                            >
                              <el-input
                                v-model="
                                  editFormData.addedServiceList[index]
                                    .chargeLimit
                                "
                                size="small"
                                class="edit-form__input3"
                                placeholder="请输入"
                                :disabled="copyVipPrice"
                              ></el-input>
                            </el-form-item>
                            <span class="symbol input-after">拒收</span>
                            <br />
                            <span class="input-before">外箱尺寸单边大于</span>
                            <el-form-item
                              label="大型包裹尺寸(大于)"
                              :prop="
                                'addedServiceList[' + index + '].chargeFrom'
                              "
                              :rules="
                                editFormData.addedServiceList[index]
                                  .isPremium !== 1
                                  ? formRules.no
                                  : formRules.require
                              "
                              class="hide-label"
                            >
                              <el-input
                                v-model="
                                  editFormData.addedServiceList[index]
                                    .chargeFrom
                                "
                                size="small"
                                class="edit-form__input3"
                                placeholder="请输入"
                                :disabled="copyVipPrice"
                              ></el-input>
                            </el-form-item>
                            <span class="symbol input-after">CM，</span>
                            <span class="symbol input-after">小于</span>
                            <el-form-item
                              label="大型包裹尺寸(小于)"
                              :prop="'addedServiceList[' + index + '].chargeTo'"
                              :rules="
                                editFormData.addedServiceList[index]
                                  .isPremium !== 1
                                  ? formRules.no
                                  : formRules.require
                              "
                              class="hide-label"
                            >
                              <el-input
                                v-model="
                                  editFormData.addedServiceList[index].chargeTo
                                "
                                size="small"
                                class="edit-form__input4"
                                placeholder="请输入"
                                :disabled="copyVipPrice"
                              ></el-input>
                            </el-form-item>
                            <span class="symbol input-after">CM，</span>
                            <span class="symbol input-after">加收</span>
                            <el-form-item
                              label="大型包裹费"
                              :prop="'addedServiceList[' + index + '].price'"
                              :rules="
                                editFormData.addedServiceList[index]
                                  .isPremium !== 1
                                  ? formRules.no
                                  : formRules.require
                              "
                              class="hide-label"
                            >
                              <el-input
                                v-model="
                                  editFormData.addedServiceList[index].price
                                "
                                size="small"
                                class="edit-form__input4"
                                placeholder="请输入"
                                :disabled="copyVipPrice"
                              ></el-input>
                            </el-form-item>
                            <span class="symbol input-after">RMB/件</span>
                          </template>
                          <!--二次送仓费-->
                          <template v-if="item.code === 'FB022'">
                            <el-form-item
                              label="二次送仓费"
                              :prop="'addedServiceList[' + index + '].price'"
                              :rules="
                                editFormData.addedServiceList[index]
                                  .isPremium !== 1
                                  ? formRules.no
                                  : formRules.require
                              "
                              class="hide-label"
                            >
                              <el-input
                                v-model="
                                  editFormData.addedServiceList[index].price
                                "
                                size="small"
                                class="edit-form__input3"
                                placeholder="请输入"
                                :disabled="copyVipPrice"
                              ></el-input>
                            </el-form-item>
                            <span class="symbol input-after">RMB/ </span>
                            <el-form-item
                              label="二次送仓费(单位)"
                              :prop="
                                'addedServiceList[' + index + '].priceUnit'
                              "
                              :rules="
                                editFormData.addedServiceList[index]
                                  .isPremium !== 1
                                  ? formRules.no
                                  : formRules.require
                              "
                              class="hide-label"
                            >
                              <el-select
                                v-model="
                                  editFormData.addedServiceList[index].priceUnit
                                "
                                size="small"
                                class="edit-form__input4"
                                placeholder="单位"
                                :disabled="copyVipPrice"
                              >
                                <el-option
                                  v-for="(item, index) in priceUnitList"
                                  :key="index"
                                  :label="item.namec"
                                  :value="item.namec"
                                ></el-option>
                              </el-select>
                            </el-form-item>
                          </template>
                          <!-- <template v-if="item.code === 'FB023'"> -->
                          <!-- <br> -->
                          <!-- <el-form-item>
                            <el-radio-group v-model="editFormData.addedServiceList[index].isPremium"
                                            class="radio-group-row">
                              <el-radio :label="item.id" v-for="item in isPremiumList" :key="item.id">{{item.name}}</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </template> -->
                        </div>
                      </div>

                      <br />
                    </template>
                    <el-radio-group
                      v-model="editFormData.isProductSurcharge"
                      class="radio-group-row"
                      :disabled="copyVipPrice"
                    >
                      <el-radio :label="true">加收</el-radio>
                      <el-radio :label="false">不加收</el-radio>
                    </el-radio-group>
                    <el-form-item
                      label="产品附加费"
                      label-width="130px"
                      label-position="right"
                    ></el-form-item>
                  </div>
                </template>
              </div>
            </el-tab-pane>
            <el-tab-pane
              label="引用平台分段报价"
              :disabled="!isPrecondition"
              name="usePlatformQuotation"
            >
              <div slot="label">
                引用平台分段报价
                <el-tooltip content="" placement="top-start" effect="dark">
                  <i class="el-icon-question" />
                  <div slot="content">
                    1.以下报价为分段供应商发布，供应商均经过平台严格筛选，可放心使用。
                    <br />
                    2.引用分段报价后，需将对应分段的操作交由该公司负责，并支付相应费用。
                  </div>
                </el-tooltip>
              </div>
              <div v-show="isPrecondition">
                <use-platform-quotation
                  ref="usePlatformQuotation"
                  :country-name="editFormData.podnamec"
                  :country-id="editFormData.podId"
                  :use-delivery-supplier-id.sync="editFormData.smartCarrierId"
                />
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-form>
        <div class="footer-active">
          <el-button
            type=""
            @click="visibleValue = false"
            class="footer-cancel"
            size="medium"
            >取消</el-button
          >
          <template v-if="isPrecondition">
            <el-button
              type=""
              @click="clickSave()"
              class="footer-save"
              size="medium"
              >保存</el-button
            >
            <el-button
              type="primary"
              @click="clickSaveAndPublish()"
              class="footer-publish"
              size="medium"
              >保存并发布</el-button
            >
          </template>
          <template v-else>
            <el-button type="info" disabled size="medium"
              >请选择“物流产品”和"有效时间"</el-button
            >
          </template>
          <!--<el-link type="warning"-->
          <!--class="margin-left-sm"-->
          <!--@click="fillTestData">-->
          <!--测试数据-->
          <!--</el-link>-->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { templateDialog } from "./templateDialog";
import {
  notifyFormValidateErrorInfo,
  getElFormValidateValue,
} from "../../../assets/js/utils";
import {
  getLineProductListByCarrierId,
  getDeliveryTypeByTransportType,
} from "../../../assets/js/baseDataRuquest";
import {
  baseDataCityRegionInnerCityItem,
  baseDataProductQuotation,
  extractSpecifiedAttribute,
  saveNeedParamsKeyArray,
  testData,
} from "./productQuotation";
import { rulesNotEmpty } from "../../../assets/js/formRules";
import { mixinsBaseInfo } from "./baseInfo";
import {
  checkGetStartCityWarehouseList,
  getRegionHeaderListDefaultChannelCode,
  getRegionHeaderListDefaultCurrency,
  getSubmitDeliveryRegionHeaderList,
  getSubmitRegionHeaderList,
  initEditDataCityRegionList,
  initEditDataRegionItem,
  insertStartCityMatchWarehouseInfo,
  mixinsFreightPrice,
  startCityMatchRegionInnerCityInfo,
} from "./freightPrice";
import { mixinsAddedService } from "@/components/QuotationManagement/components-productQuotation/addedServiceSetting";
import RegionNameAndSelect from "@/components/QuotationManagement/components-productQuotation/regionNameAndSelect";
import CustomQuotationList from "@/components/QuotationManagement/components-productQuotation/customQuotationList";
import { isArray, isObject } from "my-tools-kit";
import CityTag from "@/components/QuotationManagement/components-productQuotation/city-tag";
import CityRegionNameAndSelect from "@/components/QuotationManagement/components-productQuotation/regionNameAndSelect/cityRegionNameAndSelect";
import CityTabsRow from "@/components/QuotationManagement/components-productQuotation/cityTabsRow";
import CityRegion from "@/components/QuotationManagement/components-productQuotation/cityRegion";
import CityRegionNameAndSelect3 from "@/components/QuotationManagement/components-productQuotation/regionNameAndSelect/cityRegionNameAndSelect3";
import CityCustomQuotationList from "@/components/QuotationManagement/components-productQuotation/cityCustomQuotationList";
import qs from "qs";
import UsePlatformQuotation from "@/components/QuotationManagement/components-productQuotation/usePlatformQuotation";
import { checkSaveData } from "@/components/QuotationManagement/components-productQuotation/utils/checkSave.utils";
import { joinSaveBaseParams } from "@/components/QuotationManagement/components-productQuotation/utils/joinSaveParams.utils";
import { checkSaveAndPublishData } from "@/components/QuotationManagement/components-productQuotation/utils/checkSaveAndPublish.utils";
import SelectApiChannelCode from "@/components/QuotationManagement/components-productQuotation/selectApiChannelCode";
import { sendCustomerOperationRecord } from "../../../assets/js/baseDataRuquest";

export default {
  name: "editProductQuotationSetting",
  components: {
    SelectApiChannelCode,
    UsePlatformQuotation,
    CityCustomQuotationList,
    CityRegionNameAndSelect3,
    CityRegion,
    CityTabsRow,
    CityRegionNameAndSelect,
    CityTag,
    CustomQuotationList,
    RegionNameAndSelect,
  },
  mixins: [
    templateDialog,
    mixinsBaseInfo,
    mixinsFreightPrice,
    mixinsAddedService,
  ],
  props: {
    // data: {
    //   type: Object,
    //   default: null,
    // },
    type: {
      type: String,
      default: 'add'
    }
  },
  data() {
    return {
      loading: false,
      /* 编辑弹窗 */
      editFormData: baseDataProductQuotation(), // Object.assign({},baseDataProductQuotation(),baseDataLogisticsProductsDetails(),{regionHeaderList:[],addedServiceList:[]});
      propData: null,
      /* tab 选项卡 */
      viewTypeList: [
        { name: "基本信息", id: "baseInfo" },
        { name: "运费价格设置", id: "freightPriceSetting" },
        { name: "增值服务价格设置", id: "addedServicePriceSetting" },
        { name: "引用平台分段报价", id: "usePlatformQuotation" },
      ],
      viewTypeListValue: "baseInfo",
      /* 表单校验 */
      formRules: {
        no: [{ trigger: "blur", required: false }],
        require: [rulesNotEmpty()],
        whetherSupported: [{ trigger: "blur", required: true }],
      },
      deliveryTypeList: [
        // { label: '卡派', value: 'KP' },
        { label: "海卡", value: "HK" },
        { label: "海派", value: "HP" },
        { label: "整柜直送", value: "WC" },
        { label: "空派", value: "FP" },
        { label: "空卡", value: "KK" },
        { label: "自提", value: "ZT" },
        { label: "快递派", value: "KDP" },
        { label: "卡航", value: "KH" },
        { label: "铁路", value: "TL" },
      ],
      overseasWarehouseList: [],
      selfDeliveryList: [
        { label: "是", value: 1 }, //可自提
        { label: "否", value: 2 }, //不可自提
        // {label:"必须自提",value:3,},
      ],
      // 截仓起运时间下拉
      sailingInfoList: ["周一", "周二", "周三", "周四", "周五", "周六", "周天"],
      transportCodeMapping: {
        KY: "航空",
        HY: "船运",
        LY: "陆运",
      },
      transportNameMapping: {
        KY: "空运",
        HY: "海运",
        LY: "陆运",
      },
      copyVipPrice: false, //是否复制VIP报价
    };
  },
  mounted() {
    console.log(
      "this.editFormData.logisticsProductId",
      this.editFormData.logisticsProductId
    );
    this.getAllCurrencyList();
  },
  beforeDestroy() {
    // 调用销毁 API 对当前编辑器实例进行销毁
    if (this.editor !== null) this.editor.destroy();
  },
  methods: {
    getProductList() {
      //获取
    },
    /**
     * 切换 分区报价类型
     */
    changeRegionQuotationType(item, index) {
      this.regionQuotationTypeCurrent = item.value || "";
    },
    regionTabsDisabled(item) {
      if (this.editFormData.deliveryType === "ZT") {
        if (item.value === "delivery") return true;
      }
      return false;
    },
    /**
     * 从 tableHeadList 中获取默认的 chargeType
     * @param tableHeadList {Array}
     */
    getTableHeadChargeType(tableHeadList = []) {
      if (isArray(tableHeadList) && tableHeadList.length) {
        let firstItem = tableHeadList[0] || {};
        return firstItem.chargeType || "-";
      }
      return "-";
    },
    /**
     * 填充测试数据
     */
    fillTestData() {
      this.validTimeValue = ["2021-05-12 00:00", "2021-05-28 00:00"];
      this.editFormData = testData();
    },
    /**
     * 合并编辑数据
     */
    mergeParams(target = {}, holdTime = false) {
      let data = {};
      let now = {}; //当前编辑需要保留内容
      if (holdTime) {
        if (this.editFormData.effectiveStartTime)
          now.effectiveStartTime = this.editFormData.effectiveStartTime;
        if (this.editFormData.effectiveEndTime)
          now.effectiveEndTime = this.editFormData.effectiveEndTime;
      }
      if (target instanceof Array) {
        Object.assign(data, ...target, now);
      } else {
        Object.assign(data, target, now);
      }
      this.editFormData = data;
      this.setDeliveryList();
      if (
        this.editFormData.effectiveStartTime &&
        this.editFormData.effectiveEndTime
      ) {
        this.validTimeValue = [
          this.editFormData.effectiveStartTime,
          this.editFormData.effectiveEndTime,
        ];
      } else {
        this.validTimeValue = [];
      }
      this.setEditorContent();
    },
    /**
     * 切换选项卡
     */
    handleClickViewType(e) {},
    /**
     * 点击保存
     */
    clickSave() {
      let result = checkSaveData.call(this);
      if (isArray(result)) return this.$message.error("" + result[0]);
      let data = this.disposeSaveData(1);
      console.log("点击 仅保存", data);
      if (data.regionType === 5 && !this.checkRepeatZipCode(data)) return;
      this.sendSave(data, 1);
      if (data.id) {
        const formData = this.editFormData;
        const transportNameMapping = this.transportNameMapping;
        const operationText = `专线产品名称：${
          formData.lineProductName || "-"
        }，运输方案：${formData.transportScheme || "-"}，起运地：${
          formData.polCityList.map((item) => item.cityName).join(",") || "-"
        }，目的国：${formData.podnamec}，运输方式：${
          transportNameMapping[formData.transportType] || "-"
        }`;
        sendCustomerOperationRecord("修改报价", operationText);
      }
    },
    /**
     * 保存并发布
     */
    clickSaveAndPublish(formName = "editForm", state = 2) {
      // if(!0){
      let result = checkSaveAndPublishData.call(this);
      if (isArray(result)) {
        return this.$message.error("" + result[0]);
      }
      if (
        !this.editFormData.compensationStandards &&
        (this.editFormData.whetherSupportedCompensate ||
          this.editFormData.whetherSupportCompensation)
      ) {
        this.changeEditorTarget("compensationStandards");
        return this.$message.error(
          "您选择了支持赔付选项，请填写赔付标准说明内容"
        );
      }

      let data = this.disposeSaveData(state);
      console.log("点击 保存并发布", data);
      if (data.regionType === 5 && !this.checkRepeatZipCode(data)) return;
      this.sendSave(data, state);
      // 操作记录
      const buttonText = data.copyFromId ? "复制报价提交" : "新增报价提交";
      const formData = this.editFormData;
      const transportNameMapping = this.transportNameMapping;
      const operationText = `${
        data.copyFromId ? "关联报价ID：" + data.copyFromId + "，" : ""
      }专线产品名称：${formData.productname || "-"}，运输方案：${
        formData.transportScheme || "-"
      }，起运地：${
        formData.polCityList.map((item) => item.cityName).join(",") || "-"
      }，目的国：${formData.podnamec}，运输方式：${
        transportNameMapping[formData.transportType] || "-"
      }`;
      sendCustomerOperationRecord(buttonText, operationText);

      // }else{
      //   console.log('loading = ', this.loading);
      //   this.loading = true;
      //   this.$refs[formName].validate((valid) => {
      //     if (!valid) {
      //       setTimeout(() => this.loading = false, 500);
      //       // let form = this.$refs[formName];
      //       // let results = getElFormValidateValue(form);
      //       // return notifyFormValidateErrorInfo.call(this,results);
      //       return false;
      //     }
      //     let result = true;
      //     try {
      //       result = this.checkRegionListData();
      //     }catch (e) {
      //       result = false;
      //       console.error(e)
      //     }
      //     if (!result) {
      //       setTimeout(() => this.loading = false, 500);
      //       return false;
      //     }
      //
      //     let data = this.disposeSaveData(2);
      //     this.sendSave(data,state);
      //   });
      // }
    },
    /**
     * 处理提交数据
     * @param state {number}  保存类型 1-仅保存 2-保存并发布
     * @returns {*}
     */
    disposeSaveData(state) {
      // let data = extractSpecifiedAttribute(this.editFormData,saveNeedParamsKeyArray);
      let data = joinSaveBaseParams(this.editFormData);
      const shippingCompanyList = data.shippingCompanyList;
      const selectShippingCompanyList = this.transportCompanyList.filter(
        (item) => shippingCompanyList.includes(item.id)
      );
      const mappedSelectShippingCompanyList = selectShippingCompanyList.map(
        (item) => {
          return {
            id: item.id,
            shippingCompanyName: item.namec,
          };
        }
      );
      data.shippingCompanyList = mappedSelectShippingCompanyList;
      console.log("this.editFormData: ", this.editFormData);
      try {
        data = JSON.parse(JSON.stringify(data));
      } catch (e) {
        data = {};
      }
      if (state === 1) {
        // 非多渠道时的专线api对接渠道代码
        data.channelCode = this.editFormData.channelCode || "";
        // 币种（全包/分段头程）
        data.currencyHead = this.currency;
        // 币种（分段派送）
        data.currencyDelivery = this.currencyDelivery;
      }
      data.isConvertOnPartition = this.isConvertOnPartition;
      // 增值服务
      let quoteAttachPrice = data.quoteAttachPrice || {};
      data.quoteAttachPrice = Object.assign(
        {
          beginTime: data.effectiveStartTime,
          endTime: data.effectiveEndTime,
          id: quoteAttachPrice.id || "",
          countryId: data.podId,
        },
        this.disposeFormAddedServiceListToQuoteAttachPrice()
      );

      if (state === 2) {
        // 过滤未使用的收货城市
        let haveNeedCity = [];
        this.cityRegionHeaderList.forEach((item) =>
          haveNeedCity.push(...item.cityList)
        );
        haveNeedCity = haveNeedCity.map((item) => item.id);
        data.polCityList = data.polCityList.filter((item) =>
          haveNeedCity.includes(item.id)
        );
      }
      data.polCityList = JSON.parse(JSON.stringify(data.polCityList));
      startCityMatchRegionInnerCityInfo(
        data.polCityList,
        this.cityRegionHeaderList
      );
      insertStartCityMatchWarehouseInfo(
        data.polCityList,
        this.startCitySettingWarehouseParams
      );

      // 全包/头程 分区价格信息列表
      let supportRenewal = false; //是否支持首续重
      let isOnlySupportRenewal = false; //首重续重 是否支持多分段报价
      let isCollectRenewalFee = false; //超出续重区间是否仍收取首重费
      if (isArray(this.logisticsProductsDetails.tableHeadList)) {
        let first = this.logisticsProductsDetails.tableHeadList[0];
        if (isObject(first)) {
          supportRenewal = first.supportRenewal || false;
          isOnlySupportRenewal = first.isOnlySupportRenewal || false;
          isCollectRenewalFee = first.isCollectRenewalFee || false;
        }
      }
      data.regionHeaderList = getSubmitRegionHeaderList(
        this.cityRegionHeaderList,
        {
          currency: this.currency,
          isSegment: this.logisticsProductsDetails.isSegment,
          regionType: data.regionType,
          goodsTypeList: data.goodsTypeList,
          supportRenewal,
          isCollectRenewalFee,
          isOnlySupportRenewal,
          startCitySettingWarehouseParams: this.startCitySettingWarehouseParams,
        }
      );

      // 派送 分区价格信息列表
      if (this.editFormData.deliveryType !== "ZT") {
        let containerId = ""; //按车计费，卡车id
        let supportRenewal = false; //是否支持首续重
        let isOnlySupportRenewal = false; //首重续重 是否支持多分段报价
        let isCollectRenewalFee = false; //超出续重区间是否仍收取首重费
        if (isArray(this.logisticsProductsDetails.deliveryTableHeadList)) {
          let first = this.logisticsProductsDetails.deliveryTableHeadList[0];
          if (isObject(first)) {
            containerId = first.containerId || "";
            supportRenewal = first.supportRenewal || false;
            isOnlySupportRenewal = first.isOnlySupportRenewal || false;
            isCollectRenewalFee = first.isCollectRenewalFee || false;
          }
        }
        data.deliveryRegionHeaderList = getSubmitDeliveryRegionHeaderList(
          this.deliveryRegionHeaderList,
          {
            currency: this.currencyDelivery,
            regionType: data.regionType,
            containerId,
            supportRenewal,
            isCollectRenewalFee,
            isOnlySupportRenewal,
          }
        );
      }
      if (this.type === 'add') {
        data.priceHeaderRank = 1
      }
      if (this.copyVipPrice) {
        data.priceHeaderRank = 2
        data.ordinaryPriceHeaderId = data.copyFromId
      }

      return data;
    },
    /**
     * 检查邮编分区内是否有重复邮编
     * @param data
     * @returns {Promise<boolean>}
     */
    async checkRepeatZipCode(data) {
      const params = {
        isSegment: this.logisticsProductsDetails.isSegment,
        regionHeaderList: data.regionHeaderList,
        deliveryRegionHeaderList: data.deliveryRegionHeaderList || [],
      };
      const response = await this.axios
        .post("/api/carrier/productPriceNew/verifyZipCodeByZone", params)
        .catch(() => {
          this.$message.error("检查分区内邮编时异常，请稍候重试");
        });
      if (response) {
        if (response.data.code != 200) {
          this.$message.error(response.data.message);
          return false;
        } else if (response.data.datas && response.data.datas.length) {
          this.$message.error(
            `您所选的分区名称存在重复的邮编号:${response.data.datas.join(
              ","
            )};同一起运地，同一货物类型，同一分区信息内不允许有重复的邮编号，请检查。`
          );
          return false;
        } else {
          return true;
        }
      } else {
        this.$message.error("检查分区内邮编时异常，请稍候重试");
        return false;
      }
    },
    /**
     * 发送保存请求
     * @param state {number}  保存类型 1-仅保存 2-保存并发布
     */
    sendSave(data = {}, state = 1) {
      if (!isObject(data)) data = {};
      let label = "仅保存";
      if (state) {
        data.state = state;
        label = state === 1 ? "仅保存" : "保存并发布";
      } else if (data.state) {
        label = data.state === 1 ? "仅保存" : "保存并发布";
      } else {
        data.state = 1;
      }
      let url =
        "/api//carrier/productPriceNew/insertOrUpdateCarrierProductPrice";
      this.loading = true;
      this.axios
        .post(url, data)
        .then((res) => {
          res = isObject(res.data) ? res.data : {};
          if (res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then((res) => {
          this.loading = false;
          this.$message.success(`${label}成功`);
          this.visibleValue = false;
          this.$emit("saveSuccess");
        })
        .catch((res) => {
          this.loading = false;
          this.$message.error(
            `${label}:${res.message || "网络异常，请稍后再试"}`
          );
        });
    },
    /**
     * 提交成功后 清空数据
     * */
    resetEditFormData() {
      this.viewTypeListValue = "baseInfo";

      this.validTimeValue = [];
      this.logisticsProductsDetails = {};
      this.overseasWarehouseList = [];
      this.editFormData = baseDataProductQuotation();
      this.setDeliveryList();

      /* 分区设置 */
      this.regionQuotationTypeCurrent = "head";
      this.regionHeaderList = [];
      this.deliveryRegionHeaderList = [];
      this.currency = "";
      this.currencyDelivery = "";
      this.isConvertOnPartition = false;
      this.subareaList = [];
      this.cgCityList = [];
      this.subareaListCity = [];
      this.subareaListMapObject = [];

      this.cityRegionHeaderList = [];
      this.cityRegionHeaderCurrent = "";
      this.cityRegionHeaderPriceTable = [];
      this.deliveryCityRegionHeaderPriceTable = [];

      let $usePlatformQuotation = this.$refs.usePlatformQuotation;
      if (
        $usePlatformQuotation &&
        typeof $usePlatformQuotation.resetData === "function"
      )
        $usePlatformQuotation.resetData();

      // this.plusSubareaItem();
    },
    /**
     * 关闭回调
     */
    closed() {
      this.resetEditFormData();
      // 重置 获取专线API对接渠道代码 的状态
      if (this.apiChannelCodeListGetStatus === 2)
        this.apiChannelCodeListGetStatus = 0;
    },
    /**
     * 获取海外仓
     * @param countryId
     */
    getOverseasWarehouseList(countryId = "") {
      let url = `/api/carrier/base/findCarrierOverseasWarehouseList`;
      let data = {
        countryId,
      };
      this.axios
        .post(url, qs.stringify(data))
        .then((res) => {
          res = isObject(res.data) ? res.data : {};
          if (res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then((res) => {
          this.overseasWarehouseList = res.datas || [];
        })
        .catch((res) => {
          this.overseasWarehouseList = [];
        });
    },
    setDeliveryList() {
      const name =
        this.editFormData.transportNamec ||
        this.allTransportTypesMapObject[this.editFormData.transportType] ||
        this.editFormData.transportType;
      switch (name) {
        case "海运":
          this.deliveryTypeList = [
            { label: "海卡", value: "HK" },
            { label: "海派", value: "HP" },
            { label: "整柜直送", value: "WC" },
            { label: "自提", value: "ZT" },
          ];
          break;
        case "空运":
          this.deliveryTypeList = [
            { label: "空卡", value: "KK" },
            { label: "空派", value: "FP" },
            { label: "快递派", value: "KDP" },
            { label: "自提", value: "ZT" },
          ];
          break;
        case "陆运":
          this.deliveryTypeList = [
            { label: "卡航", value: "KH" },
            { label: "铁路", value: "TL" },
            { label: "自提", value: "ZT" },
          ];
          break;

        default:
          this.deliveryTypeList = [
            { label: "海卡", value: "HK" },
            { label: "海派", value: "HP" },
            { label: "整柜直送", value: "WC" },
            { label: "空派", value: "FP" },
            { label: "空卡", value: "KK" },
            { label: "自提", value: "ZT" },
            { label: "快递派", value: "KDP" },
            { label: "卡航", value: "KH" },
            { label: "铁路", value: "TL" },
          ];
          break;
      }
    },

    /**
     * 初始化要编辑的数据
     */
    initEditData(newValue = {}, copyVipPrice = false) {
      if (!newValue.logisticsProductCarrierId) {
        this.$confirm(
          "该条记录缺失【logisticsProductCarrierId】,无法复制，抱歉!",
          {
            confirmButtonText: "确定",
            showCancelButton: false,
            type: "warning",
          }
        ).then(() => {
          this.visibleValue = false;
        });
        return false;
      }
      this.copyVipPrice = copyVipPrice
      let logisticsProductId = newValue.logisticsProductId;
      let effectiveStartTime = newValue.effectiveStartTime;
      let effectiveEndTime = newValue.effectiveEndTime;
      let oldRegionHeaderList = [];
      if (newValue.regionHeaderList) {
        oldRegionHeaderList = newValue.regionHeaderList;
        oldRegionHeaderList.forEach((item) => {
          if (isArray(item.cityList))
            item.cityList.forEach((cityItem) => {
              if (typeof cityItem.pickUpFlag !== "boolean") {
                console.log(
                  `【${cityItem.cityName}】pickUpFlag = ${cityItem.pickUpFlag},初始化默认值`,
                  false
                );
                cityItem.pickUpFlag = false;
              }
            });
        });
        newValue.regionHeaderList = [];
      }
      let oldDeliveryRegionHeaderList = [];
      if (newValue.deliveryRegionHeaderList) {
        oldDeliveryRegionHeaderList = newValue.deliveryRegionHeaderList;
        newValue.deliveryRegionHeaderList = [];
      }
      this.isConvertOnPartition = newValue.isConvertOnPartition || false;

      this.getLogisticsProductsDetails(newValue.logisticsProductCarrierId).then(
        (res) => {
          let details = res.data || {};
          details.cityList = details.cityList.map((item) =>
            Object.assign(baseDataCityRegionInnerCityItem(), item)
          );
          this.logisticsProductsDetails = details;

          let data = Object.assign(baseDataProductQuotation(), newValue, {
            addedServiceList:
              this.disposeFormQuoteAttachPriceToAddedServiceList(
                newValue.quoteAttachPrice
              ),
          });
          let startCityIds = data.polCityList.map((item) => item.id);
          checkGetStartCityWarehouseList(
            startCityIds,
            this.startCitySettingWarehouseParams,
            this.startCitySettingWarehouseParamsLoading
          );
          if (data.shippingCompanyList && data.shippingCompanyList.length) {
            data.shippingCompanyList = data.shippingCompanyList.map(
              (item) => item.id
            );
          } else {
            data.shippingCompanyList = [];
          }
          this.editFormData = data;
          getDeliveryTypeByTransportType(data.transportType).then((res) => {
            this.deliveryTypeList = res.map((item) => {
              return {
                label: item.namec,
                value: item.code,
              };
            });
          });
          this.getShippingCompanyList(details.transportType);
          // this.setDeliveryList()
          this.setEditorContent();
          if (effectiveEndTime && effectiveEndTime) {
            this.validTimeValue = [effectiveStartTime, effectiveEndTime];
          } else {
            this.validTimeValue = [];
          }
          if (newValue.regionType === 6) {
            this.getGoodsTypeByProductId(newValue.logisticsProductId);
          } else {
            this.getGoodsTypeList(details.podId);
          }
          if (
            this.judgeNeedRefreshRegionTypeDetails(
              logisticsProductId,
              data.regionType
            )
          ) {
            this.getRegionTypeDetails().then((res) => {
              // if(this.tableData.length<=0) this.plusSubareaItem();
            });
            if (details.isSegment)
              this.getRegionTypeDetails(undefined, undefined, 3, true);
          }
          this.getOverseasWarehouseList(details.podId);
          this.getCgCityList(details.podId);

          if (isArray(oldRegionHeaderList) && oldRegionHeaderList.length) {
            if (!data.isSupportMultiChannel)
              data.channelCode =
                getRegionHeaderListDefaultChannelCode(oldRegionHeaderList);
            let currency =
              getRegionHeaderListDefaultCurrency(oldRegionHeaderList);
            this.currency = currency;

            const isTemplateChange =
              newValue.chargeSectionHeaderId !== details.chargeSectionHeaderId;
            this.editFormData.chargeSectionHeaderId =
              details.chargeSectionHeaderId;
            oldRegionHeaderList = this.setSegmentPriceListWhenTemplateChange(
              oldRegionHeaderList,
              "header",
              isTemplateChange
            );
            let list = initEditDataCityRegionList(oldRegionHeaderList);
            list.forEach((cityRegion) => {
              let cityList = cityRegion.cityList;
              cityList.forEach((item) => {
                let city = data.polCityList.find((city) => city.id === item.id);
                if (city) {
                  item.pickUpFlag = city.pickUpFlag;
                  item.receiveWarehouseId = city.receiveWarehouseId;
                }
              });
            });
            this.cityRegionHeaderList = list;
            if (list.length) {
              let firstItem = list[0];
              this.cityRegionHeaderCurrent = firstItem._id;
              this.$nextTick(() => {
                this.refreshCityRegionHeaderPriceTable(
                  details.isSegment ? "head" : "all",
                  list
                );
              });
            }
          } else {
            this.cityRegionHeaderList = [];
            this.currency = newValue.currencyHead || "";
          }
          if (
            details.isSegment &&
            isArray(oldDeliveryRegionHeaderList) &&
            oldDeliveryRegionHeaderList.length
          ) {
            let currency = getRegionHeaderListDefaultCurrency(
              oldDeliveryRegionHeaderList
            );
            this.currencyDelivery = currency;
            let list = oldDeliveryRegionHeaderList.map(initEditDataRegionItem);
            const isTemplateChange =
              newValue.chargeSectionHeaderId !== details.chargeSectionHeaderId;
            list = this.setSegmentPriceListWhenTemplateChange(
              list,
              "delivery",
              isTemplateChange
            );
            this.deliveryRegionHeaderList = list;
            if (list.length) {
              this.$nextTick(() => {
                setTimeout(() => {
                  this.refreshCityRegionHeaderPriceTable("delivery", list);
                }, 0);
              });
            }
          } else {
            this.deliveryRegionHeaderList = [];
            this.currencyDelivery = newValue.currencyDelivery || "";
          }
          this.$nextTick(() => {
            let $usePlatformQuotation = this.$refs.usePlatformQuotation;
            if (
              $usePlatformQuotation &&
              typeof $usePlatformQuotation.clickSearch === "function"
            )
              $usePlatformQuotation.clickSearch();
          });
        }
      );
    },
    /**
     * 复制报价模板改变的时候重新设置分段报价列表分段价格
     * @param list
     * @param type
     * @param isChangeTemplate
     * @returns {*[]}
     */
    setSegmentPriceListWhenTemplateChange(
      list = [],
      type = "header",
      isChangeTemplate
    ) {
      let segmentListName;
      if (type === "header") {
        segmentListName = "tableHeadList";
      } else {
        segmentListName = "deliveryTableHeadList";
      }
      list.forEach((regionHeader) => {
        regionHeader.priceDetailList.forEach((priceDetail) => {
          // 重置是否单询及免派
          priceDetail.isNeedInquiry = isChangeTemplate
            ? false
            : priceDetail.isNeedInquiry;
          let prices = [];
          this.logisticsProductsDetails[segmentListName].forEach(
            (head, index) => {
              const price = {
                chargeSectionDetailId: head.chargeSectionDetailId,
                id: "",
                ordinaryPrice: null,
                price: undefined,
                sectionEndNum: head.end,
                sectionStartNum: head.start,
              };
              if (!isChangeTemplate) {
                const priceItem = priceDetail.priceList[index]
                price.price = priceItem
                  ? priceItem.price
                  : undefined;
                if (this.copyVipPrice) {
                  price.ordinaryPrice = priceItem.ordinaryPrice || priceItem.ordinaryPrice === 0 ? priceItem.ordinaryPrice : priceItem.price
                  price.price = priceItem.ordinaryPrice || priceItem.ordinaryPrice === 0  ? priceItem.price : ''
                }
              }
              prices.push(price);
            }
          );
          priceDetail.priceList = prices;
        });
      });
      return list;
    },
    transportCompanyFilterMethod(value) {
      if (!value)
        this.transportCompanyListCopy = this.transportCompanyList || [];
      this.transportCompanyListCopy = this.transportCompanyListCopy.filter(
        (item) => {
          return (
            item.namec.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
            item.code.toLowerCase().indexOf(value.toLowerCase()) > -1
          );
        }
      );
    },
    // 物流产品列表
    logisticsProducts() {
      return this.logisticsProductsDetails.tableHeadList;
    },
    // 物流产品列表
    logisticsProductsKG() {
      return this.logisticsProductsDetails.deliveryTableHeadList;
    },
  },
  computed: {
    // 满足先决条件：选择物流产品 & 生效时间 & 失效时间
    isPrecondition() {
      return true;
    },
    isKG() {
      return !this.isCBM;
      // let type = this.editFormData.chargeType||'';
      // return type.toLowerCase() === 'kg'
    },
    isCBM() {
      let type = this.editFormData.chargeType || "";
      return type.toLowerCase() === "cbm";
    },
  },
  watch: {
    visibleValue(newValue) {
      this.$emit("update:visible", newValue);
      if (newValue) {
        if (!this.productList.length) {
          getLineProductListByCarrierId.call(this, undefined, false);
        }
        this.getCanGetApiChannelCode();
        this.getHPEndDeliveryList();
        this.getKPEndDeliveryList();
        this.getKHEndDeliveryList();
        this.getTLEndDeliveryList();
        this.$nextTick(() => {
          this.$refs.editForm.clearValidate();
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
input[type="number"] {
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  -moz-appearance: textfield;
}
</style>
<style lang="less">
@import "./style.less";
.FormWrap {
  position: relative;
  .index {
    position: absolute;
    left: -30px;
    top: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/editProductQuotationSetting.vue